import registry from './registry.json';
import { iconCategories as curatedIconCategories } from './categories.js';
import { ICONFONT_PROJECT_ICON_COUNT } from './config.js';

export { iconCategories as curatedIconCategories } from './categories.js';

export const iconRegistry = registry;
export const iconNames = registry.names;

/** 当前 CDN Symbol 脚本内可引用的符号数 */
export const cdnIconCount = registry.count;

/** 对外展示的图标总数（项目规模；CDN 同步后若更大则取 CDN） */
export const totalIconCount = Math.max(cdnIconCount, ICONFONT_PROJECT_ICON_COUNT);

const descByName = new Map();
for (const cat of curatedIconCategories) {
  for (const icon of cat.icons) {
    if (!descByName.has(icon.name)) {
      descByName.set(icon.name, icon.desc);
    }
  }
}

export function hasIcon(name) {
  return iconNames.includes(name);
}

export function getAllIcons() {
  return iconNames.map((name) => ({
    name,
    desc: descByName.get(name) || name,
  }));
}

export function getIconCategories() {
  const inRegistry = new Set(iconNames);
  const categorized = new Set();
  const result = [];

  for (const cat of curatedIconCategories) {
    const icons = cat.icons.filter((i) => inRegistry.has(i.name));
    icons.forEach((i) => categorized.add(i.name));
    if (icons.length) {
      result.push({ ...cat, icons });
    }
  }

  const uncategorized = iconNames
    .filter((name) => !categorized.has(name))
    .map((name) => ({ name, desc: descByName.get(name) || name }));

  if (uncategorized.length) {
    result.push({
      name: '其他（待归类）',
      nameEn: 'Uncategorized',
      icons: uncategorized,
    });
  }

  return result;
}
